import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { CreateModalTrigger } from '../components/CreateModalTrigger';
import { CustomerFields } from '../components/CustomerFields';
import { inject, observer } from 'mobx-react';
import { Glyphicon, FormControl } from 'react-bootstrap';

@inject('configurationStore', 'organizationStore')
@observer
class Customers extends Component {
  displayName = Customers.name

  state = {
    nameFilter: '',
    orgFilter: 0
  }

  setNameFilter = (event) => {
    this.setState({ nameFilter: event.target.value })
  }

  retrieveSavedOrgFilter = () => {
    const localStorageOrganization = localStorage.getItem('setOrganizationId')
    console.log("Local storage organization, ", localStorageOrganization)
    if (localStorageOrganization) {
      return parseInt(localStorageOrganization) 
    }
    return 0
  }

  setOrgFilter = (event) => {
    this.setState({ orgFilter: parseInt(event.target.value) })
    localStorage.setItem('setOrganizationId', String(event.target.value))
  }

  componentDidMount() {
    this.props.configurationStore.getCustomers();
    this.props.organizationStore.getOrganizations();
    const orgFilter = this.retrieveSavedOrgFilter()
    this.setState({ orgFilter })
  }

  renderCustomers(customers) {
    return (
      <div>
        {
          customers.slice().filter(customer => this.state.orgFilter === 0 || (customer.organizationId === this.state.orgFilter))
            .filter(customer => customer.name.toLowerCase().includes(this.state.nameFilter.toLowerCase()))
            .sort((aName, bName) => {
            const a = aName.name.toUpperCase();
            const b = bName.name.toUpperCase();
            if (a < b) {
              return -1;
            }
            if (a > b) {
              return 1;
            }
            return 0;
          }).map(customer => {
            return <h4 className='item' key={customer.id}>
              <Link to={`/customer/${customer.id}`}>
                <Glyphicon glyph='pencil'></Glyphicon> {customer.name}
              </Link>
            </h4>;
          })
        }
      </div>
    );
  }
  
  render() {
    const { configurationStore, organizationStore } = this.props;
    
    let contents = configurationStore.isLoading
      ? <p><em>Loading...</em></p>
      : this.renderCustomers(configurationStore.customers);

    return (
      <div>
        <h1>Customers</h1>
        <hr></hr>
        <CreateModalTrigger title='Create new customer' triggerText='Create Customer' 
          render={({toggle}) => (
            <CustomerFields buttonText='Create Customer' onSubmit={configurationStore.createCustomer} closeModal={toggle} configurationStore={configurationStore} organizationStore={organizationStore} />
          )}
        />
        <div className='filter-group'>
          <FormControl placeholder="Filter" value={this.state.nameFilter} onChange={this.setNameFilter} />
          <FormControl componentClass="select" value={this.state.orgFilter} onChange={this.setOrgFilter}>
              <option value="0">Filter Organization</option>
              {
                this.props.organizationStore.organizations.map(({id, name}) => <option key={id} value={id}>{name}</option>)
              }
          </FormControl>  
        </div>
        <div className='list'> 
          {contents}
        </div>
      </div>
    );
  }
}

export { Customers };